import { createContext } from 'react';
// eslint-disable-next-line import/no-cycle
import { UseToast } from './useToast';

export default createContext<UseToast>({
  show: () => {},
  hide: () => {},
});
